import { MaterialService } from './material.service';
import { Group } from './../model/group.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GroupList } from '../model/groupList.model';


@Injectable()
export class GroupService extends KiwixiService {

    apiGroup = environment.server + 'groups/';
    public appGroups: BehaviorSubject<Group[]> = new BehaviorSubject<Group[]>(null);

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals,
            materialService);
    }

    getGroupById(_id): Observable<Group> {
        const url = this.apiGroup + _id + '/';
        return this.getGroupByUrl(url);
    }

    getGroupByUrl(_url): Observable<Group> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<Group>(_url, {
            headers: header
        })
            .pipe(
                catchError(this.handleErrorObservable<any>(`getGroup`))
            );
    }

    getGroups(params: HttpParams): Observable<GroupList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<GroupList>(this.apiGroup, {
            headers: header,
            params: params
        })
            .pipe(
                map(_Groups => _Groups),
                catchError(this.handleErrorObservable<GroupList>(`getObservableGroups`))
            );
    }

    hasGroup(groupName, groupArray) {
        if (!groupArray || !Array.isArray(groupArray)) {
          return false; // Si l'array est null ou n'est pas de type array, renvoie false
        }
      
        for (const group of groupArray) {
          if (group && group.name === groupName) {
            return true; // Groupe trouvé, renvoie true
          }
        }
        return false; // Si le groupe n'est pas trouvé, renvoie false
      }
}
